<template>
  <div>
      <v-card>
            <center><div class="py-4"><b>Info Tawar Bersama Tertutup</b></div></center>
            <v-divider />
            <v-row class="pt-2">
                <v-col cols="12" sm="6">
                    <center v-if="penawaran.length < 1">
                        <b>Harga awal</b> <br>
                        Rp {{ Number(iklan.harga_awal).toLocaleString('id-ID') }}
                    </center>
                    <center v-else>
                        <b>Harga saat ini</b> <br>
                        Rp {{ Number(penawaran[0].bid).toLocaleString('id-ID') }}
                    </center>
                </v-col>
                <v-col cols="12" sm="6">
                    <div v-if="start == false && end == false">
                        <center>
                            <b>Mulai dalam</b> <br />
                            <div class="pt-1 pb-1 pl-1 pr-1 d-inline-flex grey white--text">
                                <countdown :time="countdown < 0 ? 0 : countdown" v-slot="{ days, hours, minutes, seconds }" style="font-size: 10px">
                                    {{ days }} h : {{ hours }} j : {{ minutes }} m :{{ seconds }} d
                                </countdown>
                            </div>
                        </center>
                    </div>
                    <div v-else-if="start == true && end == false">
                        <center>
                            <b>Berlangsung</b> <br />
                            <div class="pt-1 pb-1 pl-1 pr-1 d-inline-flex teal white--text">
                                <countdown :time="countdown2 < 0 ? 0 : countdown2" v-slot="{ days, hours, minutes, seconds }" style="font-size: 10px">
                                    {{ days }} h : {{ hours }} j : {{ minutes }} m :{{ seconds }} d
                                </countdown>
                            </div>
                        </center>
                    </div>
                    <div v-else-if="start == true && end == true">
                        <center><b>Tawaran Selesai</b></center>
                    </div>
                </v-col>
            </v-row>
        </v-card>
        <br>
        <v-card>
            <v-list v-if="start == false && end == false" color="#E9F4F5">
                <center><b style="color:#c90000">Pemenang</b></center>
            </v-list>
            <v-list v-else-if="start == true && end == false" color="#E9F4F5">
                <center><b style="color:#c90000">Pemenang Sementara</b></center>
            </v-list>
            <v-list v-else-if="start == true && end == true" color="#E9F4F5">
                <center><b style="color:#c90000">Pemenang</b></center>
            </v-list>
            <v-divider></v-divider>
            <v-list v-if="start == false && end == false" color="#E9F4F5">
                <v-list-item>
                    Tawar Bersama Belum Dimulai
                </v-list-item>
            </v-list>
            <v-list v-else>
                <v-list-item v-if="penawaran.length > 0">
                    <v-list-item-avatar>
                        <v-icon x-large v-if="pemenang.photo == '' || pemenang.photo == null">
                                mdi-account-circle
                        </v-icon>
                        <v-img :src="$url_img + pemenang.photo" v-else />

                    <!-- <v-img :src="getImage(seller.photo)"></v-img> -->
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title> <a>{{ pemenang.nama }}</a> </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-else>
                    <center>Belum ada penawaran</center>
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-row v-if="penawaran.length > 0" class="pt-2 px-2">
                <v-col cols="12" sm="5">
                    <div>Nomor Hp</div>
                    <div>Nomor Whatsapp</div>
                    <div>Email</div>
                </v-col>
                <v-col class="text-right" cols="12" sm="7">
                    <div v-if="pemenang.nomor_hp != undefined && pemenang.nomor_hp != ''">{{ pemenang.nomor_hp}}</div>
                    <div v-else>-</div>
                    <div v-if="pemenang.nomor_whatsapp != undefined && pemenang.nomor_whatsapp != ''">{{ pemenang.nomor_whatsapp}}</div>
                    <div v-else>-</div>
                    <div v-if="pemenang.email != undefined && pemenang.email != ''">{{ pemenang.email}}</div>
                    <div v-else>-</div>
                </v-col>
            </v-row>
        </v-card>
        <br>
        <v-card>
            <center><div class="py-3"><b>Info Penjual</b></div></center>
            <v-divider></v-divider>
            <v-list>
                <v-list-item>
                    <v-list-item-avatar>
                        <v-icon x-large v-if="seller.photo == ''">
                            mdi-account-circle
                        </v-icon>
                        <v-img :src="$url_img + seller.photo" v-else />
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title> <a>{{ seller.nama }}</a> </v-list-item-title>
                        <v-list-item-subtitle>
                            <v-avatar size="24" item class="mr-1">
                                <v-img :src="gbrRatting" alt="Ratting Penjual" contain></v-img>
                            </v-avatar>
                            <span v-if="avg.ratting_user == 1">Kurang Memuaskan</span>
                            <span v-else-if="avg.ratting_user == 2">Cukup Memuaskan</span>
                            <span v-else-if="avg.ratting_user == 3">Sangat Memuaskan</span>
                            <span v-else>Belum Ada Ulasan</span>
                    </v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-row class="pt-2 px-2">
                <v-col cols="12" sm="6">
                    <div>Nomor Hp</div>
                    <div>Nomor Whatsapp</div>
                    <div>Email</div>
                </v-col>
                <v-col class="text-right" cols="12" sm="6">
                    <div v-if="seller.nomor_hp != undefined && seller.nomor_hp != ''">{{ seller.nomor_hp}}</div>
                    <div v-else>-</div>
                    <div v-if="seller.nomor_whatsapp != undefined && seller.nomor_whatsapp != ''">{{ seller.nomor_whatsapp}}</div>
                    <div v-else>-</div>
                    <div v-if="seller.email != undefined && seller.email != ''">{{ seller.email}}</div>
                    <div v-else>-</div>
                </v-col>
            </v-row>
        </v-card>
        <br>
        <v-card>
            <center>
                <div class="py-3">
                    <b v-if="penawaran.length == 0">List Penawar</b>
                    <b v-else>List Penawar ({{ penawaran.length }})</b>
                </div>
            </center>
            <v-divider></v-divider>
                <v-list v-if="penawaran.length > 0" height="200px" style="overflow-y:scroll">
                    <v-list-item v-for="(item,index) in penawaran" :key="index">
                        <v-list-item-content>
                            <v-list-item-title>Oleh: {{item.id_uniq}}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.created_at | dateTimeFormat }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-chip :style="index == 0 ? '' : 'color:#c90000'" :color="index == 0 ? '#c90000' : '#E9F4F5'" dark>
                                Rp {{ Number(item.bid).toLocaleString('id-ID') }}
                            </v-chip>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
                <v-list v-else>
                    <center v-if="start == true && end == true">tidak ada penawar</center>
                    <center v-else>belum ada penawar</center>
                </v-list>
        </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';
import VueCountdown from '@chenfengyuan/vue-countdown';
Vue.component(VueCountdown.name, VueCountdown);

export default {
    props: ['iklan'],
    name: 'iklan-tbsatuan-tertutup',
    data: () => ({
        countdown: 0,
        countdown2: 0,
        time: '',
        seller: [],
        avg: [],
        gbrRatting: '',
        penawaran:[],
        pemenang:[],
    }),
    filters: {
        countDoc(doc) {
            if (doc !== null) {
                return true;
            }
        },
        datediff: date => {
            return moment(date).from();
        },
        dateFormat: date => {
            return moment.utc(date).format('DD MMM YYYY');
        },
        timeFormat: date => {
            return moment.utc(date).format('HH:mm');
        },
        dateTimeFormat: date => {
            return moment.utc(date).format('DD MMM YYYY HH:mm');
        }
    },
    computed: {
        now: function () {
            return this.time
        },
        start: function () {
            return moment.utc(this.now).isAfter(this.iklan.tanggal_mulai)
        },
        end: function () {
            return moment.utc(this.now).isAfter(this.iklan.tanggal_selesai)
        },
    },
    methods: {
        getCountDown(){
            let now = moment
                .utc(this.iklan.server_time)
                .toDate()
            now.setDate(now.getDate() - 1)
            let startDate = moment
                .utc(this.iklan.tanggal_mulai)
                .toDate()
            startDate.setDate(startDate.getDate() - 1)
            let endDate = moment
                .utc(this.iklan.tanggal_selesai)
                .toDate()
            endDate.setDate(endDate.getDate() - 1)
            this.countdown2 = endDate - now
            this.countdown = startDate - now
            console.log('countdown2', this.countdown2)
            console.log('countdown', this.countdown)
        },
        async getPenjual(){
            await this.$req
                .get(this.$root.$baseapi.user+'/user/v3/user', {
                    params: {
                        id: this.iklan.id_app_user,
                        limit: 1,
                    },
                })
                .then((response) => {
                    let { data } = response.data
                    this.seller = data[0]
                    console.log('Penjual', this.seller)
                })
                .catch((error) => {
                    let responses = error.response.data
                    console.log(responses.api_message)
                })
        },
        async getReviewAvgPenjual(){
            await this.$req
                .get(this.$root.$baseapi.transaksi+'/transaksi/v3/review_avg', {
                    params: {
                        id_penjual: this.seller.id,
                    },
                })
                .then((response) => {
                    let { data } = response.data
                    this.avg = data[0]
                    if (this.avg.ratting_user == 0) {
                        this.gbrRatting = '/img/penilaian/ic_tdk_nilai.webp'
                    } else if (this.avg.ratting_user == 1) {
                        this.gbrRatting = '/img/penilaian/ic_tdk_puas.webp'
                    } else if (this.avg.ratting_user == 2) {
                        this.gbrRatting = '/img/penilaian/ic_ckp_puas.webp'
                    } else if (this.avg.ratting_user == 3) {
                        this.gbrRatting = '/img/penilaian/ic_sngt_puas.webp'
                    }
                })
                .catch((error) => {
                    let responses = error.response.data
                    console.log(responses.api_message)
                })
        },
        async getListPenawar(){
            await this.$req
                .get(this.$root.$baseapi.bid+'/bid/v3/listbid', {
                    params: {
                        id_iklan: this.iklan.id,
                        limit: 100,
                    },
                })
                .then((response) => {
                    this.penawaran = response.data.data
                    // console.log('penawaran', this.penawaran)
                    this.getPemenang()
                })
                .catch((error) => {
                    let responses = error.response.data
                    console.log(responses.api_message)
                })
        },
        async getPemenang(){
            if (this.penawaran.length > 0) {
                await this.$req
                    .get(this.$root.$baseapi.user+'/user/v3/user', {
                        params: {
                            id: this.penawaran[0].id_app_user,
                            limit: 1,
                        },
                    })
                    .then((response) => {
                        let { data } = response.data
                        this.pemenang = data[0]
                        // console.log('pemenang', this.pemenang)
                    })
                    .catch((error) => {
                        let responses = error.response.data
                        console.log(responses.api_message)
                    })                
            }
        },
    },
    async created(){
        setInterval(() => {
            this.time = moment().add(moment.utc, 'h').format('YYYY-MM-DD HH:mm:ss')
        }, 1000)
        await this.getPenjual()
        await this.getReviewAvgPenjual()
        await this.getListPenawar()
        this.getCountDown()
    }
}
</script>